import React from 'react';
import { Controller } from 'react-hook-form';
import { Upload } from 'lucide-react';

export const FileField = ({ field, control, errors, theme }) => {
  return (
    <Controller
      name={field.id}
      control={control}
      rules={field.validation}
      render={({ field: { onChange, value } }) => (
        <div>
          <label className={`${theme.input} ${errors[field.id] ? theme.inputError : ''} 
                            cursor-pointer flex items-center justify-center space-x-2 py-4`}>
            <Upload size={20} />
            <span>{value?.name || field.placeholder || 'Choose file'}</span>
            <input
              type="file"
              onChange={(e) => {
                const file = e.target.files?.[0];
                if (file) {
                  onChange(file);
                }
              }}
              accept={field.accept}
              className="hidden"
              disabled={field.disabled}
            />
          </label>
        </div>
      )}
    />
  );
};